export const legends = [
  {
    id: "legend-1",
    title: "野史里的“贤妻”版本",
    text:
      "流传于民间的一种说法称，潘金莲的原型是一位品行端正的妻子，因丈夫得罪了同乡而被人编排，最终被写进小说“蒙受污名”。这个版本之所以流行，是因为它满足了人们对“翻案”的兴趣。但它属于野史与地方讲述，通常缺少可核验的史料支持，阅读时宜当作传说而非史实。",
  },
  {
    id: "legend-2",
    title: "“金莲”之名的由来",
    text:
      "“金莲”在古典语境中常与“三寸金莲”相联系，指旧时女子的缠足。小说为人物取名“金莲”，本身就带着强烈的时代印记。因此关于她名字的解读，往往和古代女性身体审美、婚姻制度等话题纠缠在一起，而不只是一个简单的姓名。",
  },
  {
    id: "legend-3",
    title: "《金瓶梅》与《水浒传》的关系",
    text:
      "《金瓶梅》是从《水浒传》的武松故事中“截取”出来另行发展的作品，书名取潘金莲、李瓶儿、庞春梅三人名字中的字。正因为这种“同人式”的展开，潘金莲在两个文本里的形象差别很大，也给了后世改编自由取舍的空间。",
  },
  {
    id: "legend-4",
    title: "现代作品里的“借用”",
    text:
      "一些当代作品并不讲述潘金莲的故事，而只是借她的名字来表达某种处境，例如以“我不是潘金莲”来讨论被误解与被标签化。这类借用说明，她早已成为一个文化符号，其含义会随着时代不断被重新填充。",
  },
];